import { z } from 'zod';

export const BlockedUser = z.object({
  id: z.string(),
  username: z.string(),
  avatarUrl: z.string().nullable(),
  blockedAt: z.string(),
});
